/**
 * Hvilken undermenu en åben KAMPAGNESIDE hører til ([D-304]).
 *
 * Kampagnens egen side (`/marketing/campaigns/<public_id>`) ligger ikke under
 * nogen af de 5 undermenuers stier, så venstremenuen kan ikke selv se, om
 * kampagnen er et udkast eller afsluttet. Kampagnesiden melder derfor fasens
 * menusti her, når kampagnen er hentet, og rydder den igen når siden forlades.
 * Ren visning: ingen adgang afgøres af værdien.
 */
import { ref } from 'vue';

export const activeCampaignMenuPath = ref<string | null>(null);
